class ComparisonSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.divider = this.querySelector('[data-comparison-divider]');
    if (!this.divider) return;

    this.position = Number.parseFloat(this.dataset.initialPosition) || 50;
    this.dragging = false;
    this.pointerId = null;

    this.handlePointerDown = (event) => {
      event.preventDefault();
      this.dragging = true;
      this.pointerId = event.pointerId;
      this.divider.setPointerCapture(event.pointerId);
      this.divider.style.transitionDuration = '0ms';
      this.divider.addEventListener('pointermove', this.handlePointerMove);
      this.divider.addEventListener('pointerup', this.handlePointerUp);
      this.divider.addEventListener('pointercancel', this.handlePointerUp);
      this.updateFromClientX(event.clientX);
    };

    this.handlePointerMove = (event) => {
      if (!this.dragging || event.pointerId !== this.pointerId) return;
      this.updateFromClientX(event.clientX);
    };

    this.handlePointerUp = (event) => {
      if (event.pointerId !== this.pointerId) return;
      this.dragging = false;
      this.divider.releasePointerCapture(this.pointerId);
      this.divider.style.transitionDuration = '';
      this.divider.removeEventListener('pointermove', this.handlePointerMove);
      this.divider.removeEventListener('pointerup', this.handlePointerUp);
      this.divider.removeEventListener('pointercancel', this.handlePointerUp);
    };

    this.handleKeydown = (event) => {
      const step = event.shiftKey ? 10 : 2;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        event.preventDefault();
        this.setPosition(this.position - step);
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.setPosition(this.position + step);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.setPosition(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.setPosition(100);
      }
    };

    this.setPosition(this.position);
    this.divider.addEventListener('pointerdown', this.handlePointerDown);
    this.divider.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    if (!this.divider) return;

    this.divider.removeEventListener('pointerdown', this.handlePointerDown);
    this.divider.removeEventListener('keydown', this.handleKeydown);
    this.divider.removeEventListener('pointermove', this.handlePointerMove);
    this.divider.removeEventListener('pointerup', this.handlePointerUp);
    this.divider.removeEventListener('pointercancel', this.handlePointerUp);
  }

  updateFromClientX(clientX) {
    const { left, width } = this.getBoundingClientRect();
    this.setPosition(((clientX - left) / width) * 100);
  }

  setPosition(value) {
    this.position = Math.min(100, Math.max(0, value));
    this.style.setProperty('--divider-x', `${this.position}%`);
    this.divider.setAttribute('aria-valuenow', `${Math.round(this.position)}`);
  }
}

if (!customElements.get('comparison-slider')) {
  customElements.define('comparison-slider', ComparisonSlider);
}
